<template>
    <div class="row">
        <h2 v-if="username" class="col-12">
            {{ $t('student-feedback-dash') + ' ' + username }}
        </h2>

        <div class="col-12">
            <InfiniteScroll
                scrollElementId="main"
                type="Feedbacktext"
                :dataUrl="`${$settings.APIBaseURL}/feedbacktext/listformsandtext`"
                dataProperty="results"
                class="list-group border-radius-2 no-border"
                itemClass="list-group border-radius-2 no-border mb-3"
                ref="infinitescroll"
            />
        </div>
    </div>
</template>

<script>
import InfiniteScroll from "src/components/InfiniteScroll"

export default {
    components: {
        InfiniteScroll,
    },
    data() {
        return {
            feedback: [],
            username: '',
        }
    },
    mounted() {
        this.getFeedback()
        this.$users.getDisplayName.call(this, this.$route.params['userid']).then((name) => {
            this.username = name
        })
    },
    methods: {
        getFeedback(){
			this.$refs.infinitescroll.getData("replace", {
                userabout_id: this.$route.params['userid'],
            });
		}
    }
}
</script>